export default __webpack_public_path__ + "static/media/DescribingPeople_14.52ed61fa.png";